module.exports = __webpack_public_path__ + "static/img/card03.1032c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/card03.png
// module id = 274
// module chunks = 6